export default "__VITE_ASSET__Do8Sb5pc__"